import styled from 'styled-components';
import { gridSizes, media } from 'utils/style';
import Header from './Header';

export default styled(Header)`
  background: #fff;
  border-bottom: solid 1px var(--grey300);
  padding: ${gridSizes('L')};
  padding-top: ${gridSizes('XL')};

  display: flex;
  .icon-container {
    width: 48px;
    margin-right: ${gridSizes('M')};
    svg {
      background: #f0f2f6;
      border-radius: 50%;
      ${media.lessThan('small')`
      width: 64px;
      height: 64px;
      `};
    }

    ${media.lessThan('small')`
    width: 64px;
    margin-right: 0;

  `};
  }
  h1 {
    font-size: 20px;
    font-weight: 500;
    color: var(--grey900);
    margin: 0;
    ${media.lessThan('small')`
   text-align: center;
   border-bottom: solid 1px var(--grey300);
   padding: ${gridSizes('M')} 0;
   font-size: ${gridSizes('M')};
  `};
  }
  p {
    font-size: ${gridSizes('M')};

    color: var(--grey900);
    margin-top: ${gridSizes('S')};
  }

  ${media.lessThan('small')`
  flex-direction: column;
justify-content: center;
align-items: center;
padding:${gridSizes('XL')} 0;
padding-top: ${gridSizes('M')};
`};

  .summary-item {
    background: #fff;
  }
`;
